module.exports = __webpack_public_path__ + "img/cc.e3defa7.svg";